import React, { useEffect, useState  } from "react";
import NAV from "./nav";
import Carousel from "./carousel";
import MFWealthCalculator from "../components/mf/MFWealthCalculator";
import {fetchMFDB} from "../api";
import TopFundsTable from "../components/mf/TopFundsTable";
import CategorySnapshot from "../components/mf/CategorySnapshot";
import RiskReturnChart from "../components/mf/RiskReturnChart";
import CategoryHeatmap from "../components/mf/CategoryHeatmap";
import ConsistentFunds from "../components/mf/ConsistentFunds";
import MFARNCard from "../components/mf/MFARNCard";
import MFFloatingAdvisorWidget from "../components/mf/MFFloatingAdvisorWidget";

const MFHomeStandalone = () => {

  useEffect(() => {
    // Tailwind CDN
    const script = document.createElement("script");
    script.src = "https://cdn.tailwindcss.com?plugins=forms,container-queries";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.tailwind.config = {
        darkMode: "class",
        theme: {
          extend: {
            colors: {
              primary: "#006e25",
              "primary-container": "#28a745",
              surface: "#f8f9fa",
              "surface-container": "#edeeef",
              "surface-container-low": "#f3f4f5",
              "surface-container-high": "#e7e8e9",
              "on-surface": "#191c1d",
              secondary: "#346669",
              error: "#ba1a1a",
            },
            fontFamily: {
              headline: ["Manrope"],
              body: ["Inter"],
            },
          },
        },
      };
    };

    // Fonts
    const fonts = document.createElement("link");
    fonts.href =
      "https://fonts.googleapis.com/css2?family=Manrope:wght@400;700;800&family=Inter:wght@300;400;500;600&display=swap";
    fonts.rel = "stylesheet";
    document.head.appendChild(fonts);

    // Icons
    const icons = document.createElement("link");
    icons.href =
      "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";
    icons.rel = "stylesheet";
    document.head.appendChild(icons);

  }, []);

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    // fetch('/api/mf/dashboard')
    //   .then(res => res.json())
      fetchMFDB()
      .then(data => {
        setDashboardData(data);
        setLoading(false);
      });

  }, []);


  if (loading) {
    return <div className="p-10">Loading...</div>;
  }

  return (

    <div className="bg-surface text-on-surface font-body">
      <div className="container-fluid position-relative p-0">
        <NAV activetag="mf"/>
        <Carousel activetag="mf"/>
        {/*<!-- Header Start -->*/}
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-1" style={{maxwidth: '50px'}}>
            <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Mutual Funds</h4>
          </div>
        </div>
      </div>
    <MFFloatingAdvisorWidget/>
      {/* HERO */}
      <section className="py-24 px-10 bg-surface-container-low">
        <div className="grid md:grid-cols-2 gap-10 items-center max-w-7xl mx-auto">

          <div>
            {/*<h1 className="text-6xl font-extrabold mb-6">*/}
            {/*  Invest Smarter in <span className="text-primary">Mutual Funds</span>*/}
            {/*</h1>*/}

            {/*<p className="mb-8 text-gray-600">*/}
            {/*  Direct access to AMCs with analytics insights.*/}
            {/*</p>*/}

            {/*<div className="flex gap-4">*/}
            {/*  <button className="bg-primary text-white px-6 py-3 rounded-full">*/}
            {/*    Start Investing*/}
            {/*  </button>*/}
            {/*  <button className="border px-6 py-3 rounded-full">*/}
            {/*    Explore Funds*/}
            {/*  </button>*/}
            {/*</div>*/}
            <MFARNCard/>
          </div>

          {/*<div className="h-[300px] bg-gray-200 rounded-2xl">*/}
          <div className="bg-white p-8 rounded-3xl">
            <MFWealthCalculator/>
          </div>
        </div>
      </section>

      {/* 🔥 ANALYTICS ENGINE (INCLUDING LARGE FEATURE) */}
      <section className="py-24 px-10 bg-surface">
        <div className="max-w-7xl mx-auto">

          <h2 className="text-4xl font-bold mb-10">
            Mutual Fund Performance
          </h2>

          <div className="grid md:grid-cols-4 gap-6">

            {/* LARGE FEATURE */}
            <div className="md:col-span-2 md:row-span-2 bg-white p-8 rounded-3xl">
              <CategorySnapshot
                data={dashboardData.category_snapshot}
              />
            </div>

            {/* METRICS */}
            <div className="md:col-span-2 md:row-span-2 bg-white p-8 rounded-3xl">
              <RiskReturnChart
                data={dashboardData.risk_return}
              />
            </div>

          </div>
        </div>
      </section>

      <section className="py-24 px-10 bg-surface-container-low">
        <div className="max-w-7xl mx-auto">

          <h2 className="text-4xl font-bold mb-10">
            Fund Consistency
          </h2>

          <div className="grid md:grid-cols-4 gap-6">

            {/* LARGE FEATURE */}
            <div className="md:col-span-4 md:row-span-10 bg-white p-8 rounded-3xl">
              <ConsistentFunds
                data={dashboardData.consistent_funds}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 px-10 bg-surface">
        <div className="max-w-7xl mx-auto">

          <h2 className="text-4xl font-bold mb-10">
            Fund Heatmap
          </h2>

          <div className="grid md:grid-cols-4 gap-6">

            {/* LARGE FEATURE */}
            <div className="md:col-span-4 md:row-span-10 bg-white p-8 rounded-3xl">
              <CategoryHeatmap
                data={dashboardData.heatmap}
              />
            </div>
          </div>
        </div>
      </section>

      {/* 🔥 CALCULATOR + RISK PROFILER */}
      {/*<section className="py-24 px-10 bg-surface-container-low">*/}
      {/*  <div className="grid md:grid-cols-2 gap-10 max-w-7xl mx-auto">*/}

      {/*    /!* CALCULATOR *!/*/}
      {/*    <div className="bg-white p-8 rounded-3xl">*/}
      {/*      /!*<h2 className="text-2xl font-bold mb-6">Wealth Calculator</h2>*!/*/}

      {/*      /!*<input type="range" className="w-full mb-4" />*!/*/}
      {/*      /!*<input type="range" className="w-full mb-4" />*!/*/}
      {/*      /!*<input type="range" className="w-full mb-4" />*!/*/}

      {/*      /!*<div className="bg-green-600 text-white p-6 rounded-xl mt-6">*!/*/}
      {/*      /!*  ₹1,26,45,210*!/*/}
      {/*      /!*</div>*!/*/}
      {/*    /!*<MFWealthCalculator/>*!/*/}
      {/*    </div>*/}
      {/*    /!* 🔥 RISK PROFILER *!/*/}
      {/*    <div>*/}
      {/*      <h2 className="text-2xl font-bold mb-6">*/}
      {/*        Find Your Investing Style*/}
      {/*      </h2>*/}

      {/*      <div className="space-y-4">*/}

      {/*        <div className="p-6 border rounded-2xl bg-white">*/}
      {/*          Conservative*/}
      {/*        </div>*/}

      {/*        <div className="p-6 border rounded-2xl bg-white">*/}
      {/*          Balanced*/}
      {/*        </div>*/}

      {/*        <div className="p-6 border rounded-2xl bg-white">*/}
      {/*          Aggressive*/}
      {/*        </div>*/}

      {/*      </div>*/}
      {/*    </div>*/}

      {/*  </div>*/}
      {/*</section>*/}

      {/* 🔥 TOP FUNDS TABLE */}
      <section className="py-24 px-10 bg-surface-container-low">
        <div className="max-w-7xl mx-auto">

          <h2 className="text-3xl font-bold mb-8">
            Top Performing Funds
          </h2>


        <TopFundsTable
        data={dashboardData.top_funds}
      />
        </div>
      </section>

      {/* 🔥 CATEGORY GRID */}
      <section className="py-24 px-10 bg-surface-container-low">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-7xl mx-auto">

          {["Equity", "Debt", "Hybrid", "ELSS"].map((c, i) => (
            <div key={i} className="p-6 bg-white rounded-2xl text-center">
              {c}
            </div>
          ))}

        </div>
      </section>

      {/* 🔥 FINAL CTA */}
      <section className="py-24 px-10 bg-green-600 text-white text-center">
        <h2 className="text-4xl font-bold mb-6">
          Ready to build your portfolio?
        </h2>

        <button className="bg-white text-green-600 px-8 py-4 rounded-full">
          Invest Now
        </button>
      </section>

    </div>
  );
};

export default MFHomeStandalone;